import { createCRUDService } from './createCRUDService';
import { DISTRICTS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(DISTRICTS.BASE);

// Export service
export const DistrictService = {
  ...baseCRUD,
};

export default DistrictService;
